<template>
  <div class="page">
    <div class="m-box">
      <img src="@/assets/img/home/Group2930.png" alt="">
      <span>审核中</span>
      <p>请等待管理员审核</p>
      <div class="m-des">
        <p>1、审核结果将通过手机短信方式发送至您注册时填写的手机号。 </p>
        <p>2、可在登录页面使用证件号码和密码登录查询审核结果，如审核不通过可重新提交申请。</p>
      </div>
      <van-button block class="x-btn-log m-btn" native-type="button" @click="goTo()">返回登录</van-button>
    </div>

  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        msg: '你好'
      }
    },
    created () {

    },
    methods: {
      goTo(){
        this.$router.replace({
          path:'/login'
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .page {
    .m-box{
      padding: 60px 34px 20px 34px;
      display: flex;
      flex-direction: column;
      align-items: center;
      >img{
        width: 76px;
        height: 76px;
      }
      >span{
        font-size: 16px;
        font-weight: bold;
        color: #F19E3B;
        margin-top: 12px;
      }
      >p{
        color: #1D232D;
        font-size: 14px;
        margin-top: 16px;
      }
      .m-des{
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        margin-top: 29px;
      }
      .m-btn{
        width: 144px;
        margin-top: 21px;
      }
    }
  }
</style>

